import { render } from "./Loader.vue?vue&type=template&id=c1e9eb96&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=c1e9eb96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c1e9eb96"

export default script